import { DealerGroup } from "../../../models/Organization/DealerGroup";
import createReducer from "../../utils/createReducer";
import ActionTypes from "./actionTypes";

export type DealerGroupStateT = {
    dealerGroups: DealerGroup[];
    activeDealerGroup?: DealerGroup;
    loadingDealerGroups: boolean;
    dealerGroupsLoaded: boolean;
};

export const initialState: DealerGroupStateT = {
    dealerGroups: [],
    loadingDealerGroups: false,
    dealerGroupsLoaded: false,
    activeDealerGroup: undefined,
};

// App Reducer
export default createReducer<DealerGroupStateT>(initialState, {
    [ActionTypes.SAVE_DEALER_GROUPS]: (state, payload: DealerGroup[]) => ({
        ...state,
        dealerGroups: payload,
        dealerGroupsLoaded: true,
    }),
    [ActionTypes.LOADING_DEALER_GROUPS]: (state, payload: boolean) => ({
        ...state,
        loadingDealerGroups: payload,
    }),
    [ActionTypes.SET_ACTIVE_DEALER_GROUP]: (state, payload: DealerGroup) => ({
        ...state,
        activeDealerGroup: payload,
    }),
    [ActionTypes.LOGOUT_ACTION]: (state) => ({
        ...state,
        ...initialState,
    }),
});
